import { useZone } from "../context/ZoneContext";

export function AdminZoneSwitch({ className = "" }) {
  const { isSuperAdmin, zone, setZoneView } = useZone();
  if (!isSuperAdmin) return null;
  return (
    <div data-testid="admin-zone-switch" className={`inline-flex items-center gap-2 ${className}`}>
      <span className="text-[11px] font-black uppercase tracking-wider text-[#75807A]">Vue Admin</span>
      <div className="inline-flex rounded-full bg-[#F0EBE1] p-0.5">
        <button
          data-testid="admin-zone-europe"
          onClick={() => setZoneView("europe")}
          className={`px-3 py-1.5 rounded-full text-sm font-bold transition-colors ${zone === "europe" ? "bg-[#2563EB] text-white" : "text-[#1A1A1A] hover:bg-black/5"}`}
        >
          🇪🇺 Europe
        </button>
        <button
          data-testid="admin-zone-africa"
          onClick={() => setZoneView("africa")}
          className={`px-3 py-1.5 rounded-full text-sm font-bold transition-colors ${zone === "africa" ? "bg-[#F26419] text-white" : "text-[#1A1A1A] hover:bg-black/5"}`}
        >
          🇨🇲 Afrique
        </button>
      </div>
    </div>
  );
}
